import React from 'react'
import Select from 'react-select'
import { useState, useEffect } from 'react';

const SelectMunicipios = (params) => {
  const [options, setOptions]= useState([])
  const [display, setDisplay]= useState('none')


    useEffect(() => {
      cargarDatos()
    }, [])

    useEffect(() => {
      if(display!=params.mostrar){
        setDisplay(params.mostrar)
      }
    })


  function cargarDatos(){
      if(options.length==0){
        let opts=[]
          for (let i=0; i<params.ciudades.length; i++){
              let item= new OptionsAuto(params.ciudades[i].codigo, params.ciudades[i].nombre)
              opts.push(item)
          }
          setOptions(opts)
      } 
  }
 
  function getChange(e){
    document.getElementById('inputValue').value=e.codigo
    document.getElementById('inputValue').click()
  }  

  return (
    <div style={{ display: display}}>
        <input type='hidden' id='inputValue' onClick={params.getMunicipio} />
        <Select  onChange={getChange} options={options} />
   </div>   
  )
}

export default SelectMunicipios

class OptionsAuto {
    constructor(codigo, label) {
        this.codigo = codigo;
        this.label = label;
}

}